module.exports = __webpack_public_path__ + "media/images/afiliado2-c205d1968a6240e61c6ffc3f1086afd9.svg";